<template>
  <div class="popup-component">
    <div class="popup-msg">
      <div class="popup-msg-section">
        <div class="safe-buygold">
          <h4>{{ $t("product") }}</h4>
          <div class="selectgold-panel goldproduct">
            <div class="planegold-txt">
              <div class="planegold-img">
                <img :src="product.media_images" v-if="product.media_images" />
                <img src="../assets/images/thumbnail-default.jpg" v-else />
              </div>
              <span class="buygold-txt-msg">{{ product.description }}</span>
            </div>
          </div>
        </div>
        <div class="safe-buygold">
          <h4>{{ $t("gold_balance") }}</h4>
          <CalculateGoldAmount />
          <div class="alert-msg">
            <div class="buygold-msg">
              <div class="alert-img">
                <img src="../assets/images/emoji_fae.svg" />
              </div>
              <span class="buygold-notice-msg">{{
                $t("available_purchasebalance")
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="submit-cancel-btn">
        <Button
          class="button cancel-btn-active active"
          @buyPaymentButton="buy"
          :btn_txt="$t('buygold')"
        ></Button>
        <Button
          class="button cancel-btn"
          @cancelPaymentDetail="cancel"
          :btn_txt="$t('cancel')"
        ></Button>
      </div>
    </div>
  </div>
</template>
<script>
import Button from "../components/Button";
import CalculateGoldAmount from "../components/CalculateGoldAmount";

export default {
  name: "GoldProductWrapper",
  components: {
    Button,
    CalculateGoldAmount
  },

  props: {
    product: Object,
    require: true
  },

  beforeDestroy() {
    document.body.classList.remove("customModelpop");
  },
  methods: {
    cancel() {
      this.$router.go(-1);
      document.body.classList.remove("customModelpop");
    },
    buy() {
      this.$router.push("/buy-gold");
    }
  }
};
</script>
